export enum GedDocumentTypeEnum {
  INSURANCE_CERTIFICATE = "Attestation d'assurance",
  COMPANY_IDENTIFICATION = 'Identification entreprise',
  RIB = 'RIB',
  PLAN = 'Plan',
  OTHERS = 'Autres',
  PICTURE = 'Photo',
  SAFETY_COMMISSION = 'Commission de sécurité',
}
